import { v4 as uuidv4 } from "uuid";
import { gloggedinuser, gselectedgroup } from "../../interfaces";
import { ConnectionState } from "../../types/connection-state";
import { getConvoKeyTimestampHires } from "../SpeechRecognizer/process_v2";
import { ChatAppResponse } from "../../api";
import { flattenHistoryToQnA } from "./recog_util";

export const createEmptyConnectionState = (): ConnectionState => {
    return {
        call_sid: "",
        account_sid: "",
        push_stream: null,
        transcriber: null,
        synthesizer: null,
        ratecv_state_in: null,
        ratecv_state_out: null,
        last_partial_result: "",
        recognized_fragments: [],
        chat_history: [],
        last_session_state: null,
        stt_processor_task: null,
        tts_task: null,
        voice_conf: {},
        lang: "",
        convo_hist: [],
        conversation_state: {
            globalConvoKey: 0,
            global_expected_next_user_response_type: "",
            global_convo_rollon_recognizing: [],
            global_convo_cadance_stamp: 0.0,
            global_convo_last_response_finish: 0.0,
            global_convo_collected: {},
            global_convo_last_response_start: 0.0,
            global_convo_last_speech_finish: 0.0,
            global_convo_last_speech_start: 0.0,
            global_convo_last_user_fininsh: 0.0,
            global_is_tracking_silence: false,
            ice_breakers: 0,
            global_is_tracking_dead_silence: false,
            global_run_on_sentence: {
                segments: [],
                recognized: []
            },
            global_convo_extr_conf: {},
            global_simple_convo_list: [],
            global_active_scenario_id: "",
            globalConvPerfRecog: 0.0,
            convoPerfOnRecogFin: 0.0
        } as ConversationState,
        group_id: null,
        company_id: null,
        user_id: null,
        group_oid: null,
        assistant_type: "",
        group_config: {},
        file_list_cache: [],
        question_and_answers_list: [],
        last_message: "",
        response_ovrrd: "",
        tts_lock: null,
        browser_audio_queue: null,
        audio_in_buffer: null,
        audio_out_buffer: null,
        audio_lock: null,
        CallerName: null,
        docextractionconfig: [],
        caller_match: null,
        pending_sentence: "",
        convolang: "",
        convo_data_historic: {},
        uniq_strings: [],
        actively_responding_to: [],
        is_trimmed_value_collection: false,
        trimmed_data_set: [],
        trimmed_step_int: 0,
        trimmed_phrase_list: [],
        max_trimmer_length: 0
    };
};

export const gen_UUID = (): string => {
    return uuidv4();
};

export const prepConnState = (loggedInUser: gloggedinuser, group: gselectedgroup, convo_hist: [user: string, response: ChatAppResponse][]): ConnectionState => {
    window.cca = createEmptyConnectionState();
    initConnValues(loggedInUser, group, convo_hist);
    return window.cca;
};

export const initConnValues = (loggedInUser: gloggedinuser, group: gselectedgroup, convo_hist: [user: string, response: ChatAppResponse][]): void => {
    let stream_sid = gen_UUID();

    window.cca = createEmptyConnectionState();
    window.cca.call_sid = stream_sid;
    window.cca.user_id = loggedInUser.userId;
    window.cca.account_sid = group.line_config.account_sid;
    //window.cca.push_stream = push_stream;
    //window.cca.transcriber = transcriber;
    //window.cca.synthesizer = synthesizer;
    //window.cca.voice_conf = voice_conf;
    //window.cca.lang = voice_conf["language"];
    window.cca.convo_hist = convo_hist;
    if (window.cca.conversation_state !== undefined) {
        window.cca.conversation_state.globalConvoKey = window.globalConvoKey;
        window.cca.conversation_state.global_expected_next_user_response_type = "conversation";
        window.cca.conversation_state.global_convo_cadance_stamp = getConvoKeyTimestampHires();
        window.cca.conversation_state.global_convo_last_response_start = getConvoKeyTimestampHires(2);
        window.cca.conversation_state.global_convo_last_response_finish = getConvoKeyTimestampHires(1);
    }
    window.cca.group_id = group.selectionId;
    window.cca.company_id = group.companyid;
    window.cca.user_id = loggedInUser.userId;
    window.cca.group_oid = group.oid;
    window.cca.assistant_type = group.assistanttype;
    window.cca.group_config = group;
    window.cca.file_list_cache = window.globalFL;
    window.cca.CallerName = ""; // caller phone number (only active for phone calls)
    window.cca.docextractionconfig = group.docextractionconfig;
    window.cca.caller_match = {}; // caller object (only active for phone calls)
    window.cca.convolang = group.convolang;
    window.cca.convo_data_historic = []; // prevous calls made (only active for phone calls)
    window.cca.question_and_answers_list = flattenHistoryToQnA(convo_hist);
    window.cca.actively_responding_to = [];
    window.cca.is_trimmed_value_collection = false;
    window.cca.trimmed_data_set = [];
};

